<div class="bg-blue persona-container">
    <apc-navbar-big [items]=navigation></apc-navbar-big>
    <div class="content">
        <apc-breadcrumbs></apc-breadcrumbs>
        <app-datatable
            [service]="homepageService.getPersonas" [defaultColumns]="defaultColumns"
            [columnsToExclude]="columnsToExclude" [section]="'personas'" [columnsNotToFilter]="columnsNotToFilter">
        </app-datatable>
    </div>
</div>
<apc-create-element-buttons [buttons]="buttons" (createEvent)="createElement($event)"></apc-create-element-buttons>